module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CgImp', {
    staticClass: "contentWrapper",
    attrs: {
      "campaignType": _vm.campaignType,
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "viewData": _vm.viewData.data
    }
  }), _vm._v(" "), _c('dateTable', {
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "campaginDaysData": _vm.viewData.daysData,
      "dataInfo": _vm.viewData.data,
      "tab": "creativeGroup"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78dce810","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/creativeGroup/CgMain.vue
// module id = 865
// module chunks = 1